import { ActionTypes } from 'redux/utils/Value'

export default ActionTypes('CAN_DELETE_RELEASE_NOTE')